"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var context_1 = require("./");
/**
 * Shorthand for passing all Chell contexts down.
 *
 * @export
 * @extends {React.Component<any, any>}
 */


var ChellContextProvider =
/** @class */
function (_super) {
  __extends(ChellContextProvider, _super);

  function ChellContextProvider(props) {
    return _super.call(this, props) || this;
  }

  ChellContextProvider.prototype.render = function () {
    var params = new URLSearchParams(this.props.location ? this.props.location.search : ''); // tslint:disable-next-line:no-backbone-get-set-outside-model

    var datasetLocation = params.get('name');
    return React.createElement(context_1.SecondaryStructureContextProvider, null, React.createElement(context_1.SpringContextProvider, {
      datasetLocation: datasetLocation ? datasetLocation : ''
    }, React.createElement(context_1.ResidueContextProvider, null, this.props.children)));
  };

  return ChellContextProvider;
}(React.Component);

exports.ChellContextProvider = ChellContextProvider;